import { motion } from 'framer-motion'
import styled, { css } from 'styled-components/macro'

import { IconChevronDown } from 'components/icons/chevron-down'
import { styleReset } from 'styles/misc'
import { theme } from 'styles/theme'
import { mq } from 'styles/mq'

export const Container = styled(motion.div)``

export const ViewportContainer = styled.div`
  position: relative;
  width: 100%;
  height: calc(100dvh - var(--header-height));
  height: calc(100vh - var(--header-height));
  height: calc(100svh - var(--header-height));
  @supports not (height: 100svh) {
    height: calc(100vh - var(--header-height));
  }
  overflow: hidden;
  @media (max-aspect-ratio: 375/630) and (max-width: 520px) {
    height: calc(80dvh - var(--header-height));
    height: calc(80vh - var(--header-height));
    height: calc(100svh - var(--header-height));
    height: auto;
    aspect-ratio: 375/600;
  }
`
export const Gradient = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background: linear-gradient(
    180deg,
    rgba(0, 0, 0, 0) 54.93%,
    rgba(0, 0, 0, 0.4) 83.61%
  );
`

export const TitleContainer = styled.div<{ $hidden: boolean }>`
  position: absolute;
  color: white;
  bottom: 0;
  font-family: ${theme.fonts.box};
  opacity: 1;
  transition: all 1s;
  transition-delay: 2s;
  margin: auto;
  left: 0;
  right: 0;
  width: calc((100% - 390px) / 12 * 8 + 210px);

  ${(props) =>
    props.$hidden === false &&
    css`
      filter: blur(5px);
      opacity: 0;
    `}

  @media (max-width: 1919px) {
    width: calc((100% - 390px) / 12 * 10 + 270px);
  }

  @media (max-width: 780px) {
    width: auto;
    margin: 0 20px;
  }
`

export const Title = styled.h1`
  font-weight: 700;
  line-height: normal;
  font-size: 7.2rem;
  text-wrap: balance;
  margin: 0 0 1rem;

  @media (max-width: 1919px) {
    font-size: 4.8rem;
  }
  @media (max-width: 1279px) {
    font-size: 3.6rem;
  }
  @media (max-width: 780px) {
    font-size: 3.2rem;
  }
  @media (max-width: 640px) {
    font-size: 2rem;
  }
  @media (max-width: 389px) {
    font-size: 1.8rem;
  }

  &.home {
    margin: 0 0 -0.5rem;
    font-size: 12rem;
    @media (max-width: 1919px) {
      font-size: 10rem;
    }
    @media (max-width: 1279px) {
      font-size: 8rem;
    }
    @media (max-width: 1023px) {
      font-size: 6.4rem;
    }
    @media (max-width: 780px) {
      font-size: 4.8rem;
    }
    @media (max-width: 580px) {
      margin: 0 0 0 0;
      font-size: 2.7rem;
    }
    @media (max-width: 389px) {
      font-size: 2.6rem;
    }
  }
`

export const Subtitle = styled.p`
  font-size: 3rem;
  margin: 0 0 6.4rem;
  @media (max-width: 1919px) {
    font-size: 2.5rem;
  }
  @media (max-width: 1279px) {
    font-size: 2rem;
  }
  @media (max-width: 1023px) {
    font-size: 1.8rem;
  }
  @media (max-width: 780px) {
    font-size: 1.7rem;
    margin: 0 0 6rem;
  }
  @media (max-width: 580px) {
    font-size: 1.6rem;
  }
  @media (max-width: 389px) {
    font-size: 1.5rem;
  }
`

export const Line = styled.div`
  position: sticky;
  bottom: 0;
  margin-bottom: -1rem;
  border-bottom: 1rem solid ${theme.colors.background};
`

export const Button = styled.button`
  --width: 9.1rem;

  ${styleReset}
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  left: calc(50% - (var(--width) / 2));
  bottom: 100%;
  width: var(--width);
  height: 3.6rem;
  box-sizing: content-box;
  border-bottom: 1px solid ${theme.colors.background};
  margin-bottom: -1px;
  cursor: pointer;
  color: inherit;
  background: url("data:image/svg+xml,%3Csvg width='91' height='36' viewBox='0 0 91 36' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M45.5 0C55.7173 0 64 8.28273 64 18.5V18.6143C65.7208 28.4246 76.9922 36 90.6416 36C90.7613 36 90.8807 35.9973 91 35.9961V36H0V35.9961C0.11924 35.9973 0.238788 36 0.358398 36C14.0091 35.9999 25.2809 28.423 27 18.6113V18.5C27 8.28273 35.2827 0 45.5 0Z' fill='white'/%3E%3C/svg%3E%0A");
`

export const Icon = styled(IconChevronDown)`
  font-size: 2.8rem;
  transition: transform 0.3s ${theme.ease.inOut};

  ${Button}:hover &, ${Button}:focus-visible & {
    transform: translateY(10%);
  }
`

export const ScrollToTop = styled(motion.button)`
  --size: 4rem;

  ${styleReset}
  position: fixed;
  right: var(--spacing-sm);
  bottom: var(--spacing-sm);
  width: var(--size);
  height: var(--size);
  border-radius: 50%;
  cursor: pointer;
  box-shadow: 0 1rem 1rem -0.5rem rgb(0 0 0 / 16%);
  background: ${theme.colors.text}
    url("data:image/svg+xml,%3Csvg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M13 7.83L16.59 11.41L18 10L12 4L6 10L7.41 11.41L11 7.83V20H13V7.83Z' fill='%23fff'/%3E%3C/svg%3E%0A")
    center center no-repeat;
  z-index: 1000;

  ${mq.large} {
    --size: 5rem;
  }
`
